import { render, staticRenderFns } from "./MedecinDetailTheseedit.vue?vue&type=template&id=49e4f694&"
import script from "./MedecinDetailTheseedit.vue?vue&type=script&lang=js&"
export * from "./MedecinDetailTheseedit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports